import React from 'react';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import * as constructionAutocompleteActions from '../../works/actions/constructionsAutocompleteActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

class ConstructionAutocomplete extends React.Component {

    componentWillMount() {
        this.props.constructionAutocompleteActions.getConstructions();
    }

    render() {
        const {
            construction,
            loading,
            constructionAutocompleteActions,
            onChange,
            disabled,
            constructions,
            date,
            handleTypeaheadRef,
            onBlur,
        } = this.props;

        let constructionsSelected = [];
        if ( construction && construction.id ) {
            constructionsSelected.push(construction);
        }

        const className = classNames(
          'input-autocomplete',
          { 'disabled': disabled}
        );

        return (
            <AsyncTypeahead
                ref={handleTypeaheadRef}
                isLoading={loading}
                onSearch={query => {
                    constructionAutocompleteActions.getConstructions(query, date);
                }}
                labelKey={construction => `${construction.code} - ${construction.name}`}
                selected={constructionsSelected}
                onChange={onChange}
                options={constructions}
                className={className}
                disabled={disabled}
                onBlur={onBlur}
                useCache={false}
            />
        );
    }

}

const mapStateToProps = (state) => {
    return {
        constructions: state.constructionAutocomplete.constructions,
        loading: state.constructionAutocomplete.loading,
    };
};

const mapDispatchToProps = dispatch => ( {
    constructionAutocompleteActions: bindActionCreators(constructionAutocompleteActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(ConstructionAutocomplete);

ConstructionAutocomplete.propTypes = {
    constructions: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    date: PropTypes.object,
    handleTypeaheadRef: PropTypes.func,
    onBlur: PropTypes.func,
};

ConstructionAutocomplete.defaultProps = {
    onChange: () => {},
    disabled: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/ConstructionAutocomplete.js